import React from "react";
import { Line } from "react-chartjs-2";
import "./style/payOffplan.css";

export const PayOffPlans = () => {
  const data = {
    labels: ["$5000", "$10000", "$15000", "$20000", "$25000", "$30000"],
    datasets: [
      {
        label: "First dataset",
        data: [33, 53, 85, 41, 44, 65],
        fill: true,
        backgroundColor: "#E6F1FF",
        borderColor: "#2A3DA3",
      },
      {
        label: "First dataset",
        data: [23, 63, 45, 80, 55, 73],
        fill: true,
        backgroundColor: "#E6F1FF",
        borderColor: "red",
      },
    ],
  };
  const transactionData = [
    {
      id: 1,
      amount: "$500",
      date: "28 feb 2023",
      status: "Yes",
    },
    {
      id: 2,
      amount: "$600",
      date: "28 feb 2023",
      status: "No",
    },
    {
      id: 3,
      amount: "$400",
      date: "28 feb 2023",
      status: "No",
    },
    {
      id: 4,
      amount: "$700",
      date: "28 feb 2023",
      status: "No",
    },
  ];
  return (
    <div>
      <div className="MainDebtDashboard">
        <div className="cardHeadingDebt">PayOff Plans</div>
      </div>
      <div className="MainDebtDashboard">
        <div className="strategyCard" style={{ width: "59%" }}>
          <div className="cardHeadingDebt">Balance</div>
          <div style={{ marginTop: "1rem" }}>
            <Line
              data={data}
              options={{
                legend: {
                  display: false,
                },
                scales: {
                  xAxes: [
                    {
                      gridLines: {
                        color: "rgba(0, 0, 0, 0)",
                      },
                    },
                  ],
                  yAxes: [
                    {
                      gridLines: {
                        color: "rgba(0, 0, 0, 0)",
                      },
                    },
                  ],
                },
                plugins: {},
              }}
            />
          </div>
        </div>
        <div className="strategyCard" style={{ width: "39%" }}>
          <div className="cardHeadingDebt">Record Your Transactions</div>

          <React.Fragment>
          {transactionData && transactionData.length > 0 ? (
            transactionData.map((item, index) => (
              <div key={index} className="list-row-noBg">
                <div className="listname-dark">
                  <div>{item.date}</div>
                  <div style={{color:"#26C0E2", fontWeight:"400"}}>{item.amount}</div>
                </div>
                <div className="listStatus">{item.status}</div>
              </div>
            ))
          ) : (
            <div
            className="nodata"
            
            >
              No Data to Show
            </div>
          )}
        </React.Fragment>

        </div>
      </div>
    </div>
  );
};
